module.exports = __webpack_public_path__ + "media/images/payments/coinkite-9200a75ef442733b0c84cfabcd695201.svg";